import { defineMessages } from "react-intl";
import * as helperFunctions from 'shared/utils/HelperFunctions';
/**
 * Returns an error message object based on the ApolloError received
 * @param error ApolloError
 * @returns Error message object
 */
export const getApolloErrorMessage = (error) => {
    var _a, _b;
    const messages = defineMessages({
        notAuthorized: {
            id: "not_authorized",
            defaultMessage: "Not authorized",
        },
    });
    if (error.networkError && ((_b = (_a = error.networkError.result) === null || _a === void 0 ? void 0 : _a.errors) === null || _b === void 0 ? void 0 : _b.some((e) => { var _a; return ((_a = e.extensions) === null || _a === void 0 ? void 0 : _a.code) === "AUTH_NOT_AUTHORIZED"; }))) {
        return [{ message: messages.notAuthorized.defaultMessage }];
    }
    else {
        return helperFunctions.getGenericErrorObject();
    }
};
